import { DataRoomNdaSigner } from 'router/subrouters/DataRoom/models/DataRoomNDA';
import { getSignerInfo } from './components/DataRoomNdasTable/components';

export const getSignerNdaSigning = (
  signer: DataRoomNdaSigner,
  dataRoomNdaId: string,
) =>
  signer.dataRoomNdaSignings?.find(
    (signing) => signing.dataRoomNdaId === dataRoomNdaId,
  );

export const getIsSignerSelected = (
  selected: DataRoomNdaSigner[],
  signer: DataRoomNdaSigner,
) => selected.some(({ _id }) => _id === signer._id);

export const getSignerIds = (signers: DataRoomNdaSigner[]) =>
  signers.map(({ _id }) => _id);

export const getFirstSignerName = (signers: DataRoomNdaSigner[]) =>
  getSignerInfo(signers[0]).name;
